import { NewModal as LibModal, NewModalProps as LibModalProps } from "@flaminem/ui-components";
import { FC } from "react";

import { useT } from "src/internationalization";

export type ModalProps = Omit<LibModalProps, "languageTexts">;

export const Modal: FC<ModalProps> = (props) => {
  const t = useT();

  return (
    <LibModal
      {...props}
      languageTexts={{
        close: t("general.actions.close"),
      }}
    />
  );
};
